import { render, staticRenderFns } from "./f2g-select.vue?vue&type=template&id=38bba902"
import script from "./f2g-select.vue?vue&type=script&lang=js"
export * from "./f2g-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports